import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import AuthCallbackPage from "@/app/AuthCallbackPage";

const authCallbackSearchSchema = z.object({
  code: z.string().optional(),
  next: z.string().optional(),
});

export const Route = createFileRoute("/auth/callback")({
  validateSearch: authCallbackSearchSchema,
  component: AuthCallbackPage,
});
